import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import { app_url } from "app_config"
import AllClients from "pages/Clients/AllClients"

// =============================================================

import WorkFlowMaster from "pages/Main Master/Workflow"
import DeadlineMaster from "pages/Main Master/Deadline"
import FinanceMaster from "pages/Main Master/Finance"
import ClientInfoMaster from "pages/Main Master/Client Info"

import AllPracticeMasters from "pages/Main Master/Practice Master"
import AddPractice from "pages/Main Master/Practice Master/AddPractice"
import EditPractice from "pages/Main Master/Practice Master/EditPractice"

import AllAddressType from "pages/Main Master/Address Type"
import ReferenceMaster from "pages/Main Master/Reference"
import AccessPermission from "pages/Main Master/Access Permission"
import AllTasks from "pages/Tasks"
import AddTask from "pages/Tasks/AddTask"
import AllStaffs from "pages/Staff"
import AddStaff from "pages/Staff/AddStaff"
import EditStaff from "pages/Staff/EditStaff"
import AddClient from "pages/Clients/Add Client"
import EmailsIndex from "pages/Emails"
import RolesPermission from "pages/Roles Permission"
import AddRole from "pages/Roles Permission/AddRole"
import EditRole from "pages/Roles Permission/EditRole"
import AllServiceMaster from "pages/Main Master/Service Master"
import ActivityLogs from "pages/Activity Logs"
import Invoices from "pages/Invoices"
import AllTimeSheets from "pages/Timesheet"
import NotificationIndex from "pages/Notifications"
import GocardlessPayments from "pages/Gocardless payments"
import EmailLogs from "pages/Email Logs Report"
import ReportsIndex from "pages/Reports"
import NotFound from "components/Common/NotFound"
import ArchiveTasks from "pages/Tasks/ArchiveIndex"
import CHLogs from "pages/CH Logs"
import ActiveTimers from "pages/Active Timers"
import ScheduledEmailLogs from "pages/Scheduled Email Logs"
import EmployeeReport from "pages/Employee Report"
import EmployeeWeeklyReport from "pages/Employee Weekly Report"
import EmployeeDailyReport from "pages/Employee Daily Report"
import InvoicePaymentReport from "pages/Invoice & Payment Report"
import EmployeeDesignationReport from "pages/Employee Designation Report"
import ActiveTaskLastLog from "pages/Active Task Last Update"
import BudgetMaster from "pages/Main Master/Budget Master"
import BudgetReport from "pages/Budget Report"
import UrgentAttentionReport from "pages/Urgent Attention Report"
import AllMeetings from "pages/Meeting"
import AddMeeting from "pages/Meeting/AddMeeting"
import EditMeeting from "pages/Meeting/EditMeeting"
import AutomatedReportsSummary from "pages/Automated Reports Summary"
import ServiceTagMaster from "pages/Main Master/Service Tag Master"
import ClientEmails from "pages/Client Emails"
import MissingACTRTaskReport from "pages/Missing ACTR Task Report"

const authProtectedRoutes = [
  { path: `${app_url}dashboard`, component: <Dashboard /> },

  // main masters
  // workflow
  { path: `${app_url}master/workflow-master`, component: <WorkFlowMaster /> },
  {
    path: `${app_url}master/workflow-master/:tab_name`,
    component: <WorkFlowMaster />,
  },

  // deadline
  { path: `${app_url}master/deadline-master`, component: <DeadlineMaster /> },
  {
    path: `${app_url}master/deadline-master/:tab_name`,
    component: <DeadlineMaster />,
  },

  // finance
  { path: `${app_url}master/finance-master`, component: <FinanceMaster /> },
  {
    path: `${app_url}master/finance-master/:tab_name`,
    component: <FinanceMaster />,
  },

  // ClientInfoMaster
  {
    path: `${app_url}master/client-info-master`,
    component: <ClientInfoMaster />,
  },
  {
    path: `${app_url}master/client-info-master/:tab_name`,
    component: <ClientInfoMaster />,
  },

  {
    path: `${app_url}master/address-type-master`,
    component: <AllAddressType />,
  },

  { path: `${app_url}master/service-master`, component: <AllServiceMaster /> },
  { path: `${app_url}master/budget-master`, component: <BudgetMaster /> },

  ,
  { path: `${app_url}master/reference-master`, component: <ReferenceMaster /> },
  {
    path: `${app_url}master/reference-master/:tab_name`,
    component: <ReferenceMaster />,
  },

  {
    path: `${app_url}master/access-permission`,
    component: <AccessPermission />,
  },

  {
    path: `${app_url}master/practice-master`,
    component: <AllPracticeMasters />,
  },
  { path: `${app_url}master/add-practice-master`, component: <AddPractice /> },
  {
    path: `${app_url}master/edit-practice-master/:practice_id`,
    component: <EditPractice />,
  },

  { path: `${app_url}email-templates`, component: <EmailsIndex /> },
  // { path: `${app_url}emails/:tab_name`, component: <EmailsIndex /> },

  { path: `${app_url}roles-and-permissions`, component: <RolesPermission /> },
  { path: `${app_url}add-role`, component: <AddRole /> },
  { path: `${app_url}edit-role/:role_id`, component: <EditRole /> },

  // =================================================================================

  // //clients
  { path: `${app_url}clients`, component: <AllClients /> },
  { path: `${app_url}add-client`, component: <AddClient /> },
  { path: `${app_url}edit-client/:client_id`, component: <AddClient /> },

  // task management
  { path: `${app_url}tasks`, component: <AllTasks /> },
  { path: `${app_url}archived-tasks`, component: <ArchiveTasks /> },
  { path: `${app_url}add-task`, component: <AddTask /> },
  { path: `${app_url}edit-task/:task_id`, component: <AddTask /> },

  { path: `${app_url}employees`, component: <AllStaffs /> },
  { path: `${app_url}add-employees`, component: <AddStaff /> },
  { path: `${app_url}edit-employees/:emp_id`, component: <EditStaff /> },

  { path: `${app_url}report/audit-logs`, component: <ActivityLogs /> },
  { path: `${app_url}report/employee-report`, component: <EmployeeReport /> },
  {
    path: `${app_url}report/company-house-details-update-logs`,
    component: <CHLogs />,
  },
  {
    path: `${app_url}report/scheduled-email-logs`,
    component: <ScheduledEmailLogs />,
  },

  { path: `${app_url}invoices`, component: <Invoices /> },

  {
    path: `${app_url}report/timesheet`,
    component: <AllTimeSheets isReportees={false} />,
  },
  {
    path: `${app_url}report/reportee-timesheet`,
    component: <AllTimeSheets isReportees={true} />,
  },
  {
    path: `${app_url}report/employee/weekly/report`,
    component: <EmployeeWeeklyReport />,
  },
  {
    path: `${app_url}report/employee/daily/report`,
    component: <EmployeeDailyReport />,
  },
  {
    path: `${app_url}report/active/employee/timer`,
    component: <ActiveTimers />,
  },
  { path: `${app_url}notifications`, component: <NotificationIndex /> },
  {
    path: `${app_url}report/gocardless-payments`,
    component: <GocardlessPayments />,
  },
  { path: `${app_url}report/email-logs`, component: <EmailLogs /> },
  { path: `${app_url}report/reports/:tab_name`, component: <ReportsIndex /> },
  {
    path: `${app_url}report/invoice-payment-reports`,
    component: <InvoicePaymentReport />,
  },
  {
    path: `${app_url}report/employee/designation/report`,
    component: <EmployeeDesignationReport />,
  },
  {
    path: `${app_url}report/latest/tasks/log`,
    component: <ActiveTaskLastLog />,
  },
  { path: `${app_url}report/budget-report`, component: <BudgetReport /> },

  {
    path: `${app_url}report/automated/mails`,
    component: <AutomatedReportsSummary />,
  },
  {
    path: `${app_url}report/urgent/attention`,
    component: <UrgentAttentionReport />,
  },

  {
    path: `${app_url}report/actr/missing/task`,
    component: <MissingACTRTaskReport />,
  },

  {
    path: `${app_url}minutes-of-meeting`,
    component: <AllMeetings />,
  },
  { path: `${app_url}add-meeting`, component: <AddMeeting /> },
  {
    path: `${app_url}edit-meeting/:meetingId`,
    component: <EditMeeting />,
  },

  {
    path: `${app_url}master/service-tag-master`,
    component: <ServiceTagMaster />,
  },

  {
    path: `${app_url}client/emails`,
    component: <ClientEmails />,
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: app_url,
    exact: true,
    component: <Navigate to={`${app_url}dashboard`} />,
  },
]

const publicRoutes = [
  { path: `*`, component: NotFound },
  { path: `${app_url}login`, component: Login },
  { path: `${app_url}forgot-password`, component: ForgetPwd },
  { path: `${app_url}register`, component: Register },
]

export { authProtectedRoutes, publicRoutes }
